export default {
  exporting: {
    excel: false
  }
};



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/tables/initialState/dashboardMassUpload.js